import buildAnswerFormData from './buildAnswerFormData'
import buildEvidencesMap from './buildEvidencesMap'
import status from './status'

const privacyByDesign = {
  buildAnswerFormData,
  buildEvidencesMap,
  canDelete: status.canDelete,
  canEdit: status.canEdit,
  canSendToReview: status.canSendToReview,
  getStatusLabel: status.getStatusLabel,
}

export default privacyByDesign
